import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-fax-filter-list-form",
  templateUrl: "./fax-filter-list-form.component.html",
  styleUrls: ["./fax-filter-list-form.component.scss"],
})
export class FaxFilterListFormComponent implements OnChanges {
  @Input() value = "";
  @Input() placeholder = "";
  @Input() readOnly = false;
  @Input() createRequiresValue = true;
  @Input() disableCreate = false;

  @Output() createClick = new EventEmitter<string>();
  @Output() deleteClick = new EventEmitter<string>();
  @Output() valueChange = new EventEmitter<string>();

  valueFormControl = new FormControl(this.value);

  constructor() {
    this.valueFormControl.valueChanges.subscribe(value => this.valueChange.emit(value));
  }

  get isValueEmpty() {
    return this.valueFormControl.value.length === 0;
  }

  get isCreateDisabled() {
    return this.disableCreate || (this.createRequiresValue && this.isValueEmpty);
  }

  onCreateClick() {
    const currentValue = this.valueFormControl.value;

    if (currentValue || !this.createRequiresValue) {
      this.createClick.emit(currentValue);

      if (this.createRequiresValue) {
        this.resetValueFormControl();
      }
    }
  }

  onDeleteClick() {
    const currentValue = this.valueFormControl.value;

    if (currentValue) {
      this.deleteClick.emit(currentValue);
      this.resetValueFormControl();
    }
  }

  private resetValueFormControl() {
    this.valueFormControl.setValue("");
  }

  ngOnChanges(changes: SimpleChanges) {
    if ("value" in changes) {
      this.valueFormControl.setValue(changes.value.currentValue);
    }
  }
}
